<template>
  <div class="area-message">
    <h5>Групповой чат</h5>
    <messages :group_id="group_id" />
  </div>
</template>
<script>
import messages from "@/components/Pupils/Chat/GroupChatArea/Messages";

export default {
  props: {
    group_id: {
      default: null,
    },
  },
  computed: {},
  components: {
    messages,
  },
  methods: {},
  created() {},
  data() {
    return {
      chat_id: null,
    };
  },
};
</script>

